import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inter-school-competition',
  templateUrl: './inter-school-competition.component.html',
  styleUrls: ['./inter-school-competition.component.scss']
})
export class InterSchoolCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
